import { takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './investmentIRRActions';
import { mkInvestmentIRR } from './investmentIRRTypes';

export function* getInvestmentIRRActionWatcher() {
  const config = resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'investment IRR',
    resourceBaseUrl: '/v2/investments/internal-rate-of-return',
    successAction: actions.getInvestmentIRRSuccess,
    failureAction: actions.getInvestmentIRRFailure,
    transformResponseToResources: (response) =>
      response.data && response.data.resources && response.data.resources.map((data) => mkInvestmentIRR(data)),
  });
  yield takeLeading(actions.getInvestmentIRR, resourceSagaUtils.qcsSyncGetResources, config);
}

export default [getInvestmentIRRActionWatcher];
